import styled from 'styled-components';

export const MenuCard = styled.div`
  background: rgba(255, 255, 255);
  box-shadow: 0 1px 3px 0 rgb(0 0 0 / 18%);
  z-index: 900; /* Juste en dessous du header (1000) */
  border-radius: 0.75rem;
  /* Positionnement (basé sur Menu.css) */
  position: fixed;
  width: 255px;
  height: calc(100vh - 3rem);
  top: 0;
  bottom: 0;
  margin: auto;
  @media all and (max-width: 1880px) {
    height: calc(100vh - 2rem);
`;
